import { render, staticRenderFns } from "./EpicentralMaterialNew.vue?vue&type=template&id=17117de5&scoped=true"
import script from "./EpicentralMaterialNew.vue?vue&type=script&lang=js"
export * from "./EpicentralMaterialNew.vue?vue&type=script&lang=js"
import style0 from "./EpicentralMaterialNew.vue?vue&type=style&index=0&id=17117de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17117de5",
  null
  
)

export default component.exports